import { render } from "./as-dropdown.vue?vue&type=template&id=c22c016a&scoped=true&ts=true"
import script from "./as-dropdown.vue?vue&type=script&lang=ts"
export * from "./as-dropdown.vue?vue&type=script&lang=ts"

import "./as-dropdown.vue?vue&type=style&index=0&id=c22c016a&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22c016a"]])

export default __exports__